function Design() {
  return(
    <div className="component">
      <div id="design">
        <h1>design</h1>
        <h2>client projects and personal work</h2>
        <div id="design-project-grid">
          <div className="design-project">
            <div>
              <h3>2025<br/>Flier for <i>2024 Texas Biennial</i> performance</h3>
            </div>
            <img src="design work for portfolio/flier for tx biennial performance.png" alt="2025 Texas Biennial flier"></img>
          </div>

          <hr/>
          <div className="design-project">
            <div>
              <h3>2023-n/a<br/>Fliers for <i><a href="https://instagram.com/tdobp" target="_blank" rel="noreferrer">STEAM</a></i> radio show</h3>
              <p>
                <i>Adobe Illustrator</i> • These were fliers that I created every week for the
                second iteration of my radio show at KTRU. The template makes editing fliers for every
                week a short process.
              </p>
            </div>
            <img src="design work for portfolio/block-of-fliers.jpg" alt="Four by four grid of fliers for STEAM radio show"></img>
          </div>

          <div className="design-project">
            <div>
              <h3>2023<br/>Physical mock-ups for Frederico Heliodoro's <i>The Weight of the News</i></h3>
              <p>
                <i>Adobe Illustrator, Adobe Photoshop</i> • These mock-ups were for a Minaret Records release. 
                As a music lover, a JAZZ lover, this is the type of work that I enjoy doing. It's even more 
                rewarding to know that I'll be holding it in my hands once it's produced and manufactured.
              </p>
            </div>
            <img src="design work for portfolio/vinyl mockup.png" alt="Vinyl cover of man smoking"></img>
          </div>
          <div className="design-project">
            <img src="design work for portfolio/digipack mockup 2.png" alt="CD cover of man smoking"></img>
          </div>
          <div className="design-project">
            <img src="design work for portfolio/digipack mockup 1.png" alt="Orange CD and CD case"></img>
          </div>

          <hr/>
          <div className="design-project">
            <div>
              <h3>2023<br/>Flier for <i>Gran Blooming</i> radio show</h3>
              <p>
                <i>Adobe Illustrator</i> • Gran Blooming is a jazz radio show that I host at KTRU 96.1FM.
                Pretty straight-forward but I find that jazz album covers can feel the same way.
              </p>
            </div>
            <img src="design work for portfolio/gran blooming flier.png" alt="Flier for jazz show"></img>
          </div>
          <hr/>

          <div className="design-project">
            <div>
              <h3>2022<br/>Physical mock-ups for Brendan Eder Ensemble's <i>Therapy</i></h3>
              <p>
                <i>Adobe Illustrator, Adobe Photoshop</i> • These are the first mock-ups I've done 
                for Minaret Records. 
              </p>
            </div>
            <img src="design work for portfolio/front vinyl cover mock-up.png" alt="Vinyl cover with warm abstract art"></img>
          </div>
          <div className="design-project">
            <img src="design work for portfolio/back vinyl cover mock-up.png" alt="Back of vinyl album with album credits and details"></img>
          </div>
          <div className="design-project">
            <img src="design work for portfolio/cd mock-up 3.png" alt="CD cover with warm abstract art"></img>
          </div>
          <div className="design-project">
            <img src="design work for portfolio/cd mock-up 1.png" alt="CD within CD case"></img>
          </div>
          <hr/>

          <div className="design-project">
            <div>
              <h3>2022<br/>Social media fliers for Beau yé Roc's <i>in homage & sport</i> beat show</h3>
              <p>
                <i>Adobe Illustrator, Adobe Photoshop</i> • in homage & sport was a show I put together
                for MythoFutuRiddim, an annual showcase for artists and musicians. 
                These fliers were made specifically for Instagram, Instagram Stories, and Facebook.
              </p>
            </div>
            <img src="design work for portfolio/beat set flier (1000 x 1000 - instagram)-01.png" alt="Instagram flier for beat show"></img>
          </div>
          <div className="design-project">
            <img src="design work for portfolio/beat set flier (1080 x 1920 - instagram stories)-01.png" alt="Instagram stories flier for beat show"></img>
          </div>
          <div className="design-project">
            <img src="design work for portfolio/beat set flier (1920 x 1080 - facebook)-01.png" alt="Facebook flier for beat show"></img>
          </div>
          <hr/>

          <div className="design-project">
            <div>
              <h3>2022<br/>Brand work for Keron Alleyne's campaign for New York State Assembly District 60</h3>
              <p>
                <i>Adobe Illustrator, Adobe InDesign, Adobe Photoshop</i> • Branding for this campaign was one of the most 
                exciting projects I'd done since I graduated from the University of Houston. I determined the brand colors
                and typography (shown on the website as well) and collaborated on the palm card with campaign volunteers. Finalizing
                this work took a lot of communication, feedback, and execution.
              </p>
              <a href="design work for portfolio/Keron palm card final.pdf" target="_blank" rel="noreferrer">Link to palm card</a><br/>
            </div>
            <img src="design work for portfolio/Keron logo stacked.png" alt="Logo for Keron Alleyne"></img>
          </div>
          <div className="design-project">
            <img src="design work for portfolio/Keron logo long.png" alt="Logo for Keron Alleyne"></img>
          </div>
          <hr/>
        </div>
      </div>
    </div>
  )
}

export default Design;